export default "__VITE_ASSET__3AXp$mq7__"